export type EnvironmentName = 'DEVELOPMENT' | 'STAGING' | 'PRODUCTION';

/**
 * Returns the environment name based on the current hostname.
 * Only reads window on the client to avoid SSR/hydration issues.
 */
export function getEnvironmentName(): EnvironmentName {
  if (typeof window === 'undefined') {
    return 'PRODUCTION';
  }
  const hostname = window.location.hostname.toLowerCase();

  // localhost or dev.careascendium.com → DEVELOPMENT
  if (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '::1' ||
    hostname === 'dev.careascendium.com'
  ) {
    return 'DEVELOPMENT';
  }

  // staging.careascendium.com or stagingasg.careascendium.com → STAGING
  if (
    hostname === 'staging.careascendium.com' ||
    hostname === 'stagingasg.careascendium.com'
  ) {
    return 'STAGING';
  }

  // www.careascendium.com or careascendium.com → PRODUCTION
  if (
    hostname === 'www.careascendium.com' ||
    hostname === 'careascendium.com'
  ) {
    return 'PRODUCTION';
  }

  return 'PRODUCTION';
}
